import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type InboundDocumentFieldsFragment = { __typename?: 'InboundDocument', id: string, source: Types.InboundDocumentSource, sourceKey: string, fileName: string, fileType: Types.InboundDocumentFileType, sizeBytes: number, pageCount?: number | null, contentHash: string, kind: Types.InboundDocumentKind, kindSource: Types.InboundDocumentKindSource, status: Types.InboundDocumentStatus, rejectReason: string, duplicateOfDocumentId?: string | null, receivedAt: Types.TDateISO, addedAt: Types.TDateISO, addedBy: string, updatedAt: Types.TDateISO, updatedBy: string, routedTo?: { __typename?: 'InboundDocumentRoute', target: Types.InboundDocumentTarget, targetRecordId: string, routedAt: Types.TDateISO, routedBy: string, counterparty?: { __typename?: 'InboundDocumentCounterparty', type: Types.InboundDocumentCounterpartyType, id: string } | null } | null, email?: { __typename?: 'InboundDocumentEmail', sender: string, originalSender: string, recipient: string, messageId: string, attachmentId: string, subject: string, noteText: string, dmarcPass: boolean, isAutomatic: boolean, ack: { __typename?: 'InboundDocumentAck', state: Types.InboundDocumentAckState, reason: string, claimedAt?: Types.TDateISO | null, sentAt?: Types.TDateISO | null, providerMessageId?: string | null } } | null };

export type InboundIntakeSettingsFieldsFragment = { __typename?: 'InboundIntakeSettings', address: string, previousAddress?: string | null, previousAddressValidUntil?: Types.TDateISO | null, rotatedAt: Types.TDateISO, replyToForwarder: boolean, acceptedFileTypes: Array<string>, maxBytes: number, allowedSenders: Array<{ __typename?: 'InboundAllowedSender', id: string, type: Types.InboundAllowedSenderType, value: string, addedAt: Types.TDateISO, addedBy: string }> };

export type GetInboundDocumentsQueryVariables = Types.Exact<{
  status?: Types.InputMaybe<Types.InboundDocumentStatus>;
}>;


export type GetInboundDocumentsQuery = { __typename?: 'Query', inboundDocuments: Array<{ __typename?: 'InboundDocument', id: string, source: Types.InboundDocumentSource, sourceKey: string, fileName: string, fileType: Types.InboundDocumentFileType, sizeBytes: number, pageCount?: number | null, contentHash: string, kind: Types.InboundDocumentKind, kindSource: Types.InboundDocumentKindSource, status: Types.InboundDocumentStatus, rejectReason: string, duplicateOfDocumentId?: string | null, receivedAt: Types.TDateISO, addedAt: Types.TDateISO, addedBy: string, updatedAt: Types.TDateISO, updatedBy: string, routedTo?: { __typename?: 'InboundDocumentRoute', target: Types.InboundDocumentTarget, targetRecordId: string, routedAt: Types.TDateISO, routedBy: string, counterparty?: { __typename?: 'InboundDocumentCounterparty', type: Types.InboundDocumentCounterpartyType, id: string } | null } | null, email?: { __typename?: 'InboundDocumentEmail', sender: string, originalSender: string, recipient: string, messageId: string, attachmentId: string, subject: string, noteText: string, dmarcPass: boolean, isAutomatic: boolean, ack: { __typename?: 'InboundDocumentAck', state: Types.InboundDocumentAckState, reason: string, claimedAt?: Types.TDateISO | null, sentAt?: Types.TDateISO | null, providerMessageId?: string | null } } | null }> };

export type GetInboundDocumentQueryVariables = Types.Exact<{
  documentId: Types.Scalars['String']['input'];
}>;


export type GetInboundDocumentQuery = { __typename?: 'Query', inboundDocument?: { __typename?: 'InboundDocument', id: string, source: Types.InboundDocumentSource, sourceKey: string, fileName: string, fileType: Types.InboundDocumentFileType, sizeBytes: number, pageCount?: number | null, contentHash: string, kind: Types.InboundDocumentKind, kindSource: Types.InboundDocumentKindSource, status: Types.InboundDocumentStatus, rejectReason: string, duplicateOfDocumentId?: string | null, receivedAt: Types.TDateISO, addedAt: Types.TDateISO, addedBy: string, updatedAt: Types.TDateISO, updatedBy: string, routedTo?: { __typename?: 'InboundDocumentRoute', target: Types.InboundDocumentTarget, targetRecordId: string, routedAt: Types.TDateISO, routedBy: string, counterparty?: { __typename?: 'InboundDocumentCounterparty', type: Types.InboundDocumentCounterpartyType, id: string } | null } | null, email?: { __typename?: 'InboundDocumentEmail', sender: string, originalSender: string, recipient: string, messageId: string, attachmentId: string, subject: string, noteText: string, dmarcPass: boolean, isAutomatic: boolean, ack: { __typename?: 'InboundDocumentAck', state: Types.InboundDocumentAckState, reason: string, claimedAt?: Types.TDateISO | null, sentAt?: Types.TDateISO | null, providerMessageId?: string | null } } | null } | null };

export type GetInboundDocumentAvailableTargetsQueryVariables = Types.Exact<{
  documentId: Types.Scalars['String']['input'];
}>;


export type GetInboundDocumentAvailableTargetsQuery = { __typename?: 'Query', availableTargets: Array<{ __typename?: 'InboundDocumentAvailableTarget', target: Types.InboundDocumentTarget, requiredCounterparty: Types.InboundDocumentCounterpartyType }> };

export type GetInboundIntakeSettingsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetInboundIntakeSettingsQuery = { __typename?: 'Query', inboundIntakeSettings?: { __typename?: 'InboundIntakeSettings', address: string, previousAddress?: string | null, previousAddressValidUntil?: Types.TDateISO | null, rotatedAt: Types.TDateISO, replyToForwarder: boolean, acceptedFileTypes: Array<string>, maxBytes: number, allowedSenders: Array<{ __typename?: 'InboundAllowedSender', id: string, type: Types.InboundAllowedSenderType, value: string, addedAt: Types.TDateISO, addedBy: string }> } | null };

export const InboundDocumentFieldsFragmentDoc = new TypedDocumentString(`
    fragment InboundDocumentFields on InboundDocument {
  id
  source
  sourceKey
  fileName
  fileType
  sizeBytes
  pageCount
  contentHash
  kind
  kindSource
  status
  rejectReason
  duplicateOfDocumentId
  routedTo {
    target
    targetRecordId
    counterparty {
      type
      id
    }
    routedAt
    routedBy
  }
  email {
    sender
    originalSender
    recipient
    messageId
    attachmentId
    subject
    noteText
    dmarcPass
    isAutomatic
    ack {
      state
      reason
      claimedAt
      sentAt
      providerMessageId
    }
  }
  receivedAt
  addedAt
  addedBy
  updatedAt
  updatedBy
}
    `, {"fragmentName":"InboundDocumentFields"});
export const InboundIntakeSettingsFieldsFragmentDoc = new TypedDocumentString(`
    fragment InboundIntakeSettingsFields on InboundIntakeSettings {
  address
  previousAddress
  previousAddressValidUntil
  rotatedAt
  allowedSenders {
    id
    type
    value
    addedAt
    addedBy
  }
  replyToForwarder
  acceptedFileTypes
  maxBytes
}
    `, {"fragmentName":"InboundIntakeSettingsFields"});
export const GetInboundDocumentsDocument = new TypedDocumentString(`
    query GetInboundDocuments($status: InboundDocumentStatus) {
  inboundDocuments(status: $status) {
    ...InboundDocumentFields
  }
}
    fragment InboundDocumentFields on InboundDocument {
  id
  source
  sourceKey
  fileName
  fileType
  sizeBytes
  pageCount
  contentHash
  kind
  kindSource
  status
  rejectReason
  duplicateOfDocumentId
  routedTo {
    target
    targetRecordId
    counterparty {
      type
      id
    }
    routedAt
    routedBy
  }
  email {
    sender
    originalSender
    recipient
    messageId
    attachmentId
    subject
    noteText
    dmarcPass
    isAutomatic
    ack {
      state
      reason
      claimedAt
      sentAt
      providerMessageId
    }
  }
  receivedAt
  addedAt
  addedBy
  updatedAt
  updatedBy
}`);
export const GetInboundDocumentDocument = new TypedDocumentString(`
    query GetInboundDocument($documentId: String!) {
  inboundDocument(documentId: $documentId) {
    ...InboundDocumentFields
  }
}
    fragment InboundDocumentFields on InboundDocument {
  id
  source
  sourceKey
  fileName
  fileType
  sizeBytes
  pageCount
  contentHash
  kind
  kindSource
  status
  rejectReason
  duplicateOfDocumentId
  routedTo {
    target
    targetRecordId
    counterparty {
      type
      id
    }
    routedAt
    routedBy
  }
  email {
    sender
    originalSender
    recipient
    messageId
    attachmentId
    subject
    noteText
    dmarcPass
    isAutomatic
    ack {
      state
      reason
      claimedAt
      sentAt
      providerMessageId
    }
  }
  receivedAt
  addedAt
  addedBy
  updatedAt
  updatedBy
}`);
export const GetInboundDocumentAvailableTargetsDocument = new TypedDocumentString(`
    query GetInboundDocumentAvailableTargets($documentId: String!) {
  availableTargets(documentId: $documentId) {
    target
    requiredCounterparty
  }
}
    `);
export const GetInboundIntakeSettingsDocument = new TypedDocumentString(`
    query GetInboundIntakeSettings {
  inboundIntakeSettings {
    ...InboundIntakeSettingsFields
  }
}
    fragment InboundIntakeSettingsFields on InboundIntakeSettings {
  address
  previousAddress
  previousAddressValidUntil
  rotatedAt
  allowedSenders {
    id
    type
    value
    addedAt
    addedBy
  }
  replyToForwarder
  acceptedFileTypes
  maxBytes
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetInboundDocuments: build.query<GetInboundDocumentsQuery, GetInboundDocumentsQueryVariables | void>({
      query: (variables) => ({ document: GetInboundDocumentsDocument, variables })
    }),
    GetInboundDocument: build.query<GetInboundDocumentQuery, GetInboundDocumentQueryVariables>({
      query: (variables) => ({ document: GetInboundDocumentDocument, variables })
    }),
    GetInboundDocumentAvailableTargets: build.query<GetInboundDocumentAvailableTargetsQuery, GetInboundDocumentAvailableTargetsQueryVariables>({
      query: (variables) => ({ document: GetInboundDocumentAvailableTargetsDocument, variables })
    }),
    GetInboundIntakeSettings: build.query<GetInboundIntakeSettingsQuery, GetInboundIntakeSettingsQueryVariables | void>({
      query: (variables) => ({ document: GetInboundIntakeSettingsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetInboundDocumentsQuery, useLazyGetInboundDocumentsQuery, useGetInboundDocumentQuery, useLazyGetInboundDocumentQuery, useGetInboundDocumentAvailableTargetsQuery, useLazyGetInboundDocumentAvailableTargetsQuery, useGetInboundIntakeSettingsQuery, useLazyGetInboundIntakeSettingsQuery } = injectedRtkApi;
